import React, { createContext, useContext, useRef, useState } from "react";
import { InterviewService } from "../../services/InterviewService";
import { toast } from "react-toastify";
import {
  translateAndSortAscendant,
  validatePhoneNumber
} from "../../common/helper";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { AvailabilityService } from "../../services/AvailabilityService";
import { CommonService } from "../../services/CommonService";
import moment from "moment";
import { GeneralService } from "../../services/GeneralService";
import { isValidEmail } from "../../common/helper";
import { showWarning } from "../../services/ModalService";
import { useGeneralContext } from "../General/Context";

const InterviewContext = createContext();

export default function InterviewContextProvider({ children }) {
  let pristineInterview = useRef();
  const [editMode, setEditMode] = useState(false);
  const [languageList, setLanguageList] = useState([]);
  const [addressZone, setAddressZone] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  const [candidateInterest, setCandidateInterest] = useState([]);
  const [errors, setErrors] = useState([]);
  const [mobility, setMobility] = useState([]);
  const [remoteWorkOptions, setRemoteWorkOptions] = useState([]);
  const [managerInterest, setManagerInterest] = useState([]);
  const [monetaryList, setMonetaryList] = useState([]);
  const [isTabsDisabled, setIsTabsDisabled] = useState(true);
  const [availabilityListStatus, setAvailabilityListStatus] = useState(false);
  const [showModalInterviewHistory, setShowModalInterviewHistory] = useState(
    false
  );
  const [interviewHistory, setInterviewHistory] = useState([{}]);
  const [changeDataPreview, setChangeDataPreview] = useState(false);
  const [shoModalSendDNA, setShowModalSendDNA] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [noticeList, setNoticeList] = useState([]);
  const [availabilityStatus, setAvailabilityStatus] = useState([]);
  const [autoCompleteCourseData, setAutoCompleteCourseData] = useState([{}]);
  const [searchCourseData, setSearchCourseData] = useState();
  const [autoCompleteSchoolData, setAutoCompleteSchoolData] = useState([{}]);
  const [searchSchoolData, setSearchSchoolData] = useState();
  const [updateDocumentsGrid, setUpdatesDocumentsGrid] = useState(false);
  const [contractTypes, setContractTypes] = useState([]);
  const [numberOfDependents, setNumberOfDependants] = useState([]);
  const [docOnlineLanguages, setDocOnlineLanguages] = useState([]);
  const [documentLanguages, setDocumentLanguages] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [languageLevelList, setLanguageLevelList] = useState([]);
  const [techSkills, setTechSkills] = useState([]);
  const [technologiesHierachy, setTechnologiesHierachy] = useState([]);
  const [newApplicationAvailable, setNewApplicationAvailable] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();
  const { userInformation } = useGeneralContext();
  const [formReady, setFormReady] = useState(false);
  const INTERVIEW = 1;

  const [interview, setInterview] = useState({
    interviewId: 0,
    interviewOrderSequence: 1,
    isActive: true,
    isFinalized: true,
    createdDate: "",
    personalInformation: {
      fullName: "",
      nationalityId: [],
      emailAddress: "",
      mobilePhoneNumber: "",
      isForeingWithOutDoc: false,
      jobRoleId: 0,
      candidateExpectativeRoleId: 0
    },
    interviewEducation: {
      candidateCourses: [{}],
      notesOfFormation: ""
    },
    candidateWorkExperience: {
      professionalExperienceYearsId: 0,
      projectsExperienceDetails: "",
      seniorityLevelsId: 0
    },
    otherSkills: "",
    skillEvaluation: "",
    otherLanguages: [{}],
    languageLevel: [],
    technologies: [],
    skills: [],
    globalRating: "",
    availabilityAndConditions: {
      availabilityId: 0,
      mobilityId: [],
      negotiable: false,
      currentSalaryValueIsLiquid: true,
      salaryExpectedValueIsLiquid: true,
      expectedSalaryCurrencyId: 1,
      CurrentSalaryCurrencyId: 1,
      remoteWorkId: [],
      noticeId: 0
    },
    docOnlineLanguageId: 0,
    docOnlineLanguageInitials: "",
    totalInterviews: 1,
    autosendDocOnline: true && userInformation.companyAbbreviation !== "GMS",
    expectedSalaryPerLocation: [
      {
        currentLocation: [{}]
      }
    ]
  });

  const [
    showModalAlertExistInterview,
    setShowModalAlertExistInterview
  ] = useState(false);
  const [messageAlertExistInterview, setMessageAlertExistInterview] = useState(
    ""
  );
  const [tabActive, setTabActive] = useState(0);

  const LoadParameters = (interviewId) => {
    Promise.all([
      GetAllAddressZone(),
      GetAllMaritalStatus(),
      GetAllNationalities(),
      GetAllJobRoles(),
      GetMobility(),
      GetRemoteWorkOptions(),
      GetManagerInterest(),
      GetAllLanguages(),
      getInitialAvailability(),
      getAllCourses(),
      getAllSchools(),
      GetAvailabilityStatus(),
      GetNoticeOptions(),
      GetContractTypes(),
      GetNumberOfDependents(),
      GetDocOnlineLanguages(),
      GetDocumentLanguages(),
      GetDocumentTypes(),
      GetAllLanguageLevels(),
      GetOrganizedTechSkills(),
      getAllTechnologiesHierachy(),
      GetMonetary()
    ])
      .catch((err) => {
        console.error("error::", err);
        toast.error(
          t("There was an error while trying to load the interview parameters.")
        );
      })
      .finally(() => {
        if (!interviewId) {
          setIsLoading(false);
        }
      });
  };

  const GetMonetary = () => {
    InterviewService.getMonetary().then((result) => {
      setMonetaryList(result);
    });
  };

  const getAllCourses = () => {
    CommonService.getAllCourses().then((courses) => {
      if (courses !== undefined) {
        setAutoCompleteCourseData(
          courses.map((course) => {
            return {
              id: course.id,
              name: course.description
            };
          })
        );
      } else {
        setAutoCompleteCourseData([]);
      }
    });
  };

  const getAllSchools = () => {
    CommonService.getAllSchools().then((schools) => {
      if (schools !== undefined) {
        setAutoCompleteSchoolData(
          schools.map((school) => {
            return {
              id: school.id,
              name: school.description
            };
          })
        );
      } else {
        setAutoCompleteSchoolData([]);
      }
    });
  };

  const getInitialAvailability = () => {
    AvailabilityService.getAvailabilityStatusByCode("IM").then((result) => {
      setInterview((prevInterview) => ({
        ...prevInterview,
        availabilityAndConditions: {
          ...prevInterview.availabilityAndConditions,
          availabilityId: result?.id
        }
      }));
    });
  };

  const GetOrganizedTechSkills = () => {
    InterviewService.getOrganizedTechnologyList().then((data) =>
      setTechSkills(translateAndSortAscendant(data, "description"))
    );
  };

  const GetManagerInterest = () => {
    InterviewService.getInterestType().then((result) =>
      setManagerInterest(translateAndSortAscendant(result, "description"))
    );
  };

  const GetAllLanguages = () => {
    InterviewService.getAllLanguages().then(function (data) {
      setLanguageList(data);
    });
  };

  const GetAllLanguageLevels = () => {
    InterviewService.getAllLanguageLevels().then((data) => {
      setLanguageLevelList(data);
    });
  };

  const calculateGlobalRating = (skills) => {
    if (skills.length > 0) {
      let total = 0;
      skills.forEach((skill) => {
        total += skill.rating * skill.weight;
      });
      let decimal = total % 1;
      if (decimal >= 0.049 && decimal < 0.06) {
        total += 0.01;
      }
      return total.toFixed(1);
    }
  };

  const getAllTechnologiesHierachy = () => {
    InterviewService.getAllTechnologiesHierachy().then((result) => {
      setTechnologiesHierachy(result);
    });
  };

  const setLastInterviewInTheContext = () => {
    const parameters = {
      fullName: interview.personalInformation.fullName,
      emailAddress: interview.personalInformation.emailAddress,
      phoneNumber: interview.personalInformation.mobilePhoneNumber
    };

    InterviewService.createCandidateProcess(parameters).then(
      (interviewData) => {
        Promise.all([
          InterviewService.getEducationInterview(interviewData.interviewId),
          InterviewService.getTechnologiesInterview(interviewData.interviewId),
          InterviewService.getSkillsInterview(interviewData.interviewId),
          InterviewService.getAllSkills()
        ])
          .then(([educationData, technologiesData, skillsData, allSkills]) => {
            if (!interviewData.error) {
              let _personalInformation = { ...interview.personalInformation };

              if (_personalInformation.birthDate) {
                interviewData.personalInformation.birthDate =
                  _personalInformation.birthDate;
              }

              if (_personalInformation.zoneId) {
                interviewData.personalInformation.zoneId =
                  _personalInformation.zoneId;
              }

              if (_personalInformation.maritalStatusId) {
                interviewData.personalInformation.maritalStatusId =
                  _personalInformation.maritalStatusId;
              }

              if (_personalInformation.numberOfDependents) {
                interviewData.personalInformation.numberOfDependents =
                  _personalInformation.numberOfDependents;
              }

              if (_personalInformation.isForeingWithOutDoc) {
                interviewData.personalInformation.isForeingWithOutDoc =
                  _personalInformation.isForeingWithOutDoc;
              }

              if (_personalInformation.nationalityId) {
                interviewData.personalInformation.nationalityId =
                  _personalInformation.nationalityId;
              }

              if (_personalInformation.linkedIn) {
                interviewData.personalInformation.linkedIn =
                  _personalInformation.linkedIn;
              }

              if (_personalInformation.gitHub) {
                interviewData.personalInformation.gitHub =
                  _personalInformation.gitHub;
              }

              if (_personalInformation.jobRoleId) {
                interviewData.personalInformation.jobRoleId =
                  _personalInformation.jobRoleId;
              }

              if (_personalInformation.candidateExpectativeRoleId) {
                interviewData.personalInformation.candidateExpectativeRoleId =
                  _personalInformation.candidateExpectativeRoleId;
              }

              if (_personalInformation.interestTypeId) {
                interviewData.personalInformation.interestTypeId =
                  _personalInformation.interestTypeId;
              }
              if (_personalInformation.currentLocation) {
                interviewData.personalInformation.currentLocation =
                  _personalInformation.currentLocation;
              }
              if (_personalInformation.techAreaId) {
                interviewData.personalInformation.techAreaId =
                  _personalInformation.techAreaId;
              }
              if (_personalInformation.techRoleId) {
                interviewData.personalInformation.techRoleId =
                  _personalInformation.techRoleId;
              }
              if (_personalInformation.candidateInterestBusinessAreaId) {
                interviewData.personalInformation.candidateInterestBusinessAreaId =
                  _personalInformation.candidateInterestBusinessAreaId;
              }
              if (_personalInformation.businessAreaId) {
                interviewData.personalInformation.businessAreaId =
                  _personalInformation.businessAreaId;
              }
              if (_personalInformation.candidateInterestTechAreaId) {
                interviewData.personalInformation.candidateInterestTechAreaId =
                  _personalInformation.candidateInterestTechAreaId;
              }
              if (_personalInformation.candidateInterestTechRoleId) {
                interviewData.personalInformation.candidateInterestTechRoleId =
                  _personalInformation.candidateInterestTechRoleId;
              }

              if (interviewData.interviewEducation) {
                if (
                  interviewData.interviewEducation.candidateCourses.length === 0
                ) {
                  interviewData.interviewEducation.candidateCourses = [{}];
                }
              } else {
                interviewData.interviewEducation = {
                  candidateCourses: [{}],
                  notesOfFormation: ""
                };
              }

              if (educationData.candidateCourses.length === 0) {
                educationData.candidateCourses = [{}];
              }

              if (!interviewData.motherLanguageId) {
                if (languageList.length > 0) {
                  interviewData.motherLanguageId = getMotherLanguageDefault(
                    languageList
                  );
                } else {
                  InterviewService.getAllLanguages().then(function (data) {
                    interviewData.motherLanguageId = getMotherLanguageDefault();
                  });
                }
              }

              if (!interviewData.availabilityAndConditions.availabilityId) {
                AvailabilityService.getAvailabilityStatusByCode("IM").then(
                  (result) => {
                    interviewData.availabilityAndConditions.availabilityId =
                      result.id;
                    interviewData.availabilityAndConditions.availabilityCode =
                      "IM";
                  }
                );
              }

              if (
                interviewData.availabilityAndConditions.salaryExpected === ""
              ) {
                interviewData.availabilityAndConditions.salaryExpected = 0;
              }

              if (skillsData.length === 0) {
                skillsData = initiateSkills(allSkills);
              }

              interviewData.docOnlineLanguageId = interview.docOnlineLanguageId;
              interviewData.docOnlineLanguageInitials =
                interview.docOnlineLanguageInitials;
              interviewData.availabilityAndConditions.salaryExpectedValueIsLiquid = true;
              interviewData.availabilityAndConditions.currentSalaryValueIsLiquid = true;
              interviewData.businessAreas = interview.businessAreas;
              interviewData.candidateBusinessAreas =
                interview.candidateBusinessAreas;

              if (
                !interviewData.availabilityAndConditions.currentSalaryCurrencyId
              ) {
                interviewData.availabilityAndConditions.currentSalaryCurrencyId = 1;
              }

              if (
                !interviewData.availabilityAndConditions
                  .expectedSalaryCurrencyId
              ) {
                interviewData.availabilityAndConditions.expectedSalaryCurrencyId = 1;
              }
              if (interviewData.expectedSalaryPerLocation.length === 0) {
                interviewData.expectedSalaryPerLocation = [{}];
              }

              setInterview({
                ...interviewData,
                interviewEducation: educationData,
                technologies: technologiesData,
                skills: skillsData,
                globalRating: calculateGlobalRating(skillsData),
                autosendDocOnline:
                  true && userInformation.companyAbbreviation !== "GMS"
              });
              setFormReady(true);
              setIsTabsDisabled(false);
            }
          })
          .catch((err) => console.error(err));
      }
    );
  };

  const GetInterviewById = (interviewId) => {
    Promise.all([
      InterviewService.getById(interviewId),
      InterviewService.getEducationInterview(interviewId),
      InterviewService.getTechnologiesInterview(interviewId),
      InterviewService.getSkillsInterview(interviewId),
      InterviewService.getAllSkills(),
      InterviewService.getAllLanguages(),
      InterviewService.GetPreviewTechnologiesInterview(interviewId),
      InterviewService.getTechnologiesHierachy(interviewId)
    ])
      .then(
        ([
          interviewData,
          educationData,
          technologiesData,
          skillsData,
          allSkills,
          languages,
          technologyDescriptionList,
          technologiesHierachy
        ]) => {
          if (!interviewData.isActive) {
            history.push(`/interview/view/${interviewId}?returnUrl=/interview`);
          }
          if (!interviewData.motherLanguageId) {
            interviewData.motherLanguageId = getMotherLanguageDefault(
              languages
            );
          }

          if (!interviewData.availabilityAndConditions.availabilityId) {
            AvailabilityService.getAvailabilityStatusByCode("IM").then(
              (result) => {
                interviewData.availabilityAndConditions.availabilityId =
                  result.id;
                interviewData.availabilityAndConditions.availabilityCode = "IM";
              }
            );
          }

          if (
            interviewData.personalInformation.nationalityId.length === 0 &&
            editMode
          ) {
            interviewData.personalInformation.nationalityId = [1];
          }

          if (interviewData.availabilityAndConditions.mobilityId === null) {
            interviewData.availabilityAndConditions.mobilityId = [];
          }

          if (
            !interviewData.availabilityAndConditions.currentSalaryCurrencyId
          ) {
            interviewData.availabilityAndConditions.currentSalaryCurrencyId = 1;
          }

          if (
            !interviewData.availabilityAndConditions.expectedSalaryCurrencyId
          ) {
            interviewData.availabilityAndConditions.expectedSalaryCurrencyId = 1;
          }

          if (skillsData.length === 0) {
            skillsData = initiateSkills(allSkills);
          }
          if (interviewData.expectedSalaryPerLocation.length === 0) {
            interviewData.expectedSalaryPerLocation = [{}];
          }
          if (
            interviewData.availabilityAndConditions.currentSalaryValueIsLiquid === undefined ||
            interviewData.availabilityAndConditions.currentSalaryValueIsLiquid === null
          ) {
            interviewData.availabilityAndConditions.currentSalaryValueIsLiquid = true;
          }
          if (
            interviewData.availabilityAndConditions.salaryExpectedValueIsLiquid === undefined || 
            interviewData.availabilityAndConditions.salaryExpectedValueIsLiquid === null 
          ) {
            interviewData.availabilityAndConditions.salaryExpectedValueIsLiquid = true;
          }

          setNewApplicationAvailable(
            checkforNewApllications(
              interviewData.applicationDetails,
              interviewData.applicationDetailId
            )
          );

          setInterview({
            ...interviewData,
            interviewEducation: educationData,
            technologies: technologiesData,
            skills: skillsData,
            globalRating: calculateGlobalRating(skillsData),
            autosendDocOnline:
              interviewData.typeOfInterview === INTERVIEW &&
              interviewData.interviewOrderSequence <= 1 &&
              userInformation.companyAbbreviation !== "GMS"
                ? true
                : false,
            candidateSelectedTechnologyList: technologyDescriptionList
          });
          setTechnologiesHierachy(technologiesHierachy);
          setFormReady(true);

          pristineInterview.current = JSON.stringify({
            ...interviewData,
            interviewEducation: educationData,
            technologies: technologiesData,
            skills: skillsData,
            globalRating: calculateGlobalRating(skillsData),
            autosendDocOnline:
              interviewData.interviewOrderSequence === 1 &&
              userInformation.companyAbbreviation !== "GMS"
                ? true
                : false,
            candidateSelectedTechnologyList: technologyDescriptionList
          });
        }
      )
      .catch((err) => console.error("err::", err))
      .finally(() => {
        setIsLoading(false);
        setIsTabsDisabled(false);
      });
  };
  function checkforNewApllications(applicationDetails, currentId) {
    let current = applicationDetails.filter((x) => x.id === currentId).shift();
    for (let app of applicationDetails) {
      if (app.date > current.date) {
        return true;
      }
    }
    return false;
  }
  const GetRemoteWorkOptions = () => {
    InterviewService.getRemoteWorkOptions().then((result) =>
      setRemoteWorkOptions(result)
    );
  };

  const GetMobility = () => {
    InterviewService.getAllMobilityInterview().then((result) =>
      setMobility(result)
    );
  };

  const GetAllJobRoles = () => {
    InterviewService.getAllJobRoles().then((result) => {
      let list = translateAndSortAscendant(result, "description");
      setJobRoles(list);
      setCandidateInterest(list);
    });
  };

  const GetAllAddressZone = () => {
    InterviewService.getAllAddressZone().then((zones) => setAddressZone(zones));
  };

  const GetAllMaritalStatus = () => {
    InterviewService.getAllMaritalStatus().then((status) =>
      setMaritalStatus(status)
    );
  };

  const GetAllNationalities = () => {
    InterviewService.getAllNationalities().then((nationalities) => {
      setNationality(nationalities);
      if (interview.personalInformation.nationalityId.length === 0) {
        let personalInformation = { ...interview.personalInformation };
        let nationality = nationalities
          .filter((item) => item.code === userInformation.langCode)
          .shift();
        if (nationality) {
          personalInformation.nationalityId.push(nationality.id);
          setInterview({
            ...interview,
            personalInformation: personalInformation
          });
        }
      }
    });
  };

  const GetNoticeOptions = () => {
    InterviewService.getNoticeOptions().then((result) => setNoticeList(result));
  };

  const GetAvailabilityStatus = () => {
    AvailabilityService.getAvailabilityStatus().then((result) =>
      setAvailabilityStatus(result)
    );
  };

  const GetContractTypes = () => {
    InterviewService.getContractType().then((result) => {
      setContractTypes(result);
    });
  };

  const GetNumberOfDependents = () => {
    InterviewService.getNumberOfDependents().then((data) =>
      setNumberOfDependants(data)
    );
  };

  const GetDocOnlineLanguages = () => {
    GeneralService.getVitaeLanguages().then((data) => {
      setDocOnlineLanguages(data);
    });
  };

  const GetDocumentLanguages = () => {
    CommonService.getAllLanguages().then((data) =>
      setDocumentLanguages(translateAndSortAscendant(data, "description"))
    );
  };

  const GetDocumentTypes = () => {
    CommonService.getAllDocumentTypes().then((data) => setDocumentTypes(data));
  };
  function saveWithOutValidateInterview() {
    saveInterview(() => {
      interview.autosendDocOnline && createAutomaticDOCOnline();
      toast.success(t("Screen call saved successfully"));
      setTimeout(() => {
        history.push(`/interview/view/${interview.interviewId}`);
      }, 3000);
    });
  }
  const saveInterview = (calback) => {
    if (formReady) {
      if (interview.interviewId === 0) {
        if (!validateInterviewMainInputs()) {
          return;
        }

        checkIfInterviewAlreadyExists();
      } else {
        let _interview = { ...interview };
        _interview.applicationDetail = getapplicationDetails();
        if (pristineInterview.current === JSON.stringify(interview)) {
          return;
        }

        InterviewService.saveInterview(_interview, false)
          .then((res) => {
            if (!res.error) {
              pristineInterview.current = JSON.stringify(interview);
              setInterview((prevInterview) => ({
                ...prevInterview,
                interviewId: res
              }));
            }
            if (calback) {
              calback();
            }
          })
          .finally(() => setIsTabsDisabled(false));
      }
    }
  };

  const checkIfInterviewAlreadyExists = () => {
    setIsTabsDisabled(true);
    const parameters = {
      fullName: interview.personalInformation.fullName,
      emailAddress: interview.personalInformation.emailAddress,
      phoneNumber: interview.personalInformation.mobilePhoneNumber,
      vitaeLanguage: localStorage.getItem("i18nextLng")
    };

    InterviewService.checkIfInterviewAlreadyExists(parameters).then(
      (result) => {
        if (result && result.message && result.message !== "") {
          setMessageAlertExistInterview(result.message);
          setShowModalAlertExistInterview(true);
        } else {
          if (!result?.error) {
            if (!interview.availabilityAndConditions.salaryExpected) {
              interview.availabilityAndConditions.salaryExpected = 0;
            }
            setLastInterviewInTheContext();
          }
        }
        setEditMode(true);
      }
    );
  };

  const initiateSkills = (skills) => {
    let initialSkills = [];
    if (skills) {
      if (skills.length > 0) {
        initialSkills = skills.map((skill) => {
          return {
            personalSkill: skill.description,
            weight: skill.weight,
            id: skill.id,
            rating: 0,
            weightId: skill.weightId
          };
        });
      }
    }
    return initialSkills;
  };

  const getMotherLanguageDefault = (allLanguages) => {
    let motherLanguage = allLanguages.filter(
      (item) => item.code === userInformation.langCode
    );
    if (motherLanguage) {
      return motherLanguage[0].id;
    }
  };

  const submitForm = () => {
    setIsTabsDisabled(true);
    const errors = _validateInterview();

    const errorFields = {
      birthDate: t("Birth date"),
      emailAddress: t("Email"),
      mobilePhoneNumber: t("Mobile number"),
      mobilityId: t("Mobility area"),
      projectsExperienceDetails: t("Main Activities"),
      rating: t("Rating"),
      technologies: t("Technical skills"),
      fullName: t("Full Name"),
      noticeId: t("Notice option"),
      fixedDate: t("Fixed date option"),
      professionalExperienceYearsId: t("Years of Experience"),
      languageLevel: t("Language level"),
      language: t("Language"),
      salaryExpected: t("Expected Salary"),
      jobRoleId: t("Job Role"),
      nationalityId: t("Nationality"),
      applicationDetailDate: t("Application date"),
      applicationDetailSource: t("Application source"),
      applicationDetailAssignUserId: t("Assign User"),
      availabilityReasonId: t("Availability Reason"),
      otherLanguages: t("Other Languages"),
      techAreaId: t("Tech Area"),
      techRoleId: t("Tech Role")
    };

    const errorFieldsMessages = Object.keys(errors)
      .map((errorKey) => errorFields[errorKey])
      .join(", ");

    if (!formReady) {
      setIsTabsDisabled(false);
      return;
    }

    if (!validateInterview()) {
      toast.warning(
        `${t("The following fields are required")}: ${errorFieldsMessages}`
      );
      setIsTabsDisabled(false);
      return;
    }

    const removedEmptyCourseBlock = interview.interviewEducation.candidateCourses.filter(
      (educationInfo) =>
        Object.keys(educationInfo).length !== 0 &&
        ((educationInfo.courseDescription ?? educationInfo.courseDescription) ||
          (educationInfo.courseId ?? educationInfo.courseId) ||
          (educationInfo.otherCourse ?? educationInfo.otherCourse) ||
          (educationInfo.otherSchool ?? educationInfo.otherSchool) ||
          (educationInfo.schoolDescription ??
            educationInfo.schoolDescription) ||
          (educationInfo.schoolId ?? educationInfo.schoolId) ||
          (educationInfo.startDate ?? educationInfo.startDate) ||
          (educationInfo.endDate ?? educationInfo.endDate))
    );

    let interviewCache = { ...interview };

    interviewCache.isFinalized = true;
    interviewCache.applicationDetail = getapplicationDetails();
    interviewCache.applicationDetail.locked = true;
    interviewCache.interviewEducation = {
      ...interviewCache.interviewEducation,
      candidateCourses: removedEmptyCourseBlock
    };

    InterviewService.saveInterview(interviewCache, true)
      .then(() => {
        interview.autosendDocOnline && createAutomaticDOCOnline();

        toast.success(t("Interview saved successfully"));
        setTimeout(() => {
          history.push(`/interview/view/${interviewCache.interviewId}`);
        }, 3000);
      })
      .finally(() => {
        setIsTabsDisabled(false);
      });
  };

  const createAutomaticDOCOnline = () => {
    InterviewService.createAutomaticDocOnline(interview.interviewId)
      .then(() => {})
      .catch(() =>
        toast.error(
          t("An error occurred sending the Doc Online email to the candidate.")
        )
      );
  };
  function getapplicationDetails() {
    return interview.applicationDetails
      .filter((x) => x.id === interview.applicationDetailId)
      .shift();
  }

  const _validateInterview = () => {
    const _erros = {};

    //validate for empty fields
    if (!interview.personalInformation.fullName) {
      _erros.fullName = t("The Full Name is required.");
    }

    if (interview.personalInformation.fullName.length > 100) {
      _erros.fullName = t("The maximum number of characters allowed is 100.");
    }

    if (!interview.personalInformation.emailAddress) {
      _erros.emailAddress = t("The Email Address is required.");
    }

    if (
      interview.personalInformation.nationalityId[0] === "0" ||
      interview.personalInformation.nationalityId[0] === 0
    ) {
      _erros.nationalityId = t("The Nationality is required.");
    }

    if (!interview.personalInformation.techAreaId) {
      _erros.techAreaId = t("The Tech Area is required.");
    }
    if (!interview.personalInformation.techRoleId) {
      _erros.techRoleId = t(" Tech Role is required.");
    }

    if (
      interview.candidateWorkExperience?.professionalExperienceYearsId ===
        "0" ||
      interview.candidateWorkExperience?.professionalExperienceYearsId === null
    ) {
      _erros.professionalExperienceYearsId = t(
        "The field Years of Experience is required."
      );
    }

    if (!interview.candidateWorkExperience?.projectsExperienceDetails) {
      _erros.projectsExperienceDetails = t(
        "The field Main Activities is required."
      );
    }

    if (!isValidEmail(interview.personalInformation.emailAddress)) {
      _erros.emailAddress = t("The Email Address is required.");
    }

    const errorPhoneNumber = validatePhoneNumber(
      interview.personalInformation.mobilePhoneNumber,
      25
    );

    if (errorPhoneNumber.format) {
      _erros.mobilePhoneNumber = t("The mobile number format is invalid.");
    } else if (errorPhoneNumber.maxLength) {
      _erros.mobilePhoneNumber =
        t("The maximum number of characters is") +
        " " +
        errorPhoneNumber.maxNum;
    }

    if (interview.globalRating === "0.0") {
      _erros.rating = t("Please select a classification for the interview.");
    }

    if (
      !interview.availabilityAndConditions.noticeId &&
      interview.availabilityAndConditions.availabilityCode === "OH"
    ) {
      if (
        interview.availabilityAndConditions.noticeId === 0 ||
        interview.availabilityAndConditions.noticeId === null ||
        interview.availabilityAndConditions.noticeId === "0"
      ) {
        _erros.noticeId = t("The notice option is required.");
      }
    }

    if (
      !interview.availabilityAndConditions.fixedDate &&
      interview.availabilityAndConditions.availabilityCode === "FD"
    ) {
      if (
        interview.availabilityAndConditions.fixedDate === null ||
        interview.availabilityAndConditions.fixedDate === undefined
      ) {
        _erros.fixedDate = t("The fixed date is required.");
      }
    }

    if (
      interview.availabilityAndConditions.fixedDate &&
      interview.availabilityAndConditions.availabilityCode === "FD"
    ) {
      if (
        moment(interview.availabilityAndConditions.fixedDate).isValid() !==
          true ||
        moment(interview.availabilityAndConditions.fixedDate).isBefore(
          new Date()
        )
      ) {
        _erros.fixedDate = t("The fixed date is invalid.");
      }
    }

    if (
      interview.availabilityAndConditions.availabilityCode === "UN" &&
      !interview.availabilityAndConditions.availabilityReasonId
    ) {
      if (
        interview.availabilityAndConditions.availabilityReasonId === 0 ||
        interview.availabilityAndConditions.availabilityReasonId === null ||
        interview.availabilityAndConditions.availabilityReasonId === "0"
      ) {
        _erros.availabilityReasonId = t("Reason is required.");
      }
    }

    if (
      interview.availabilityAndConditions.mobilityId === null ||
      interview.availabilityAndConditions.mobilityId === undefined ||
      interview.availabilityAndConditions.mobilityId.length === 0
    ) {
      _erros.mobilityId = t("At least one mobility area is required.");
    }

    if (
      !interview.availabilityAndConditions.salaryExpected ||
      interview.availabilityAndConditions.salaryExpected === "0"
    ) {
      _erros.salaryExpected = t("The salary field is required.");
    } else if (
      interview.availabilityAndConditions.salaryExpected &&
      (interview.availabilityAndConditions.salaryExpected <= "0" ||
        interview.availabilityAndConditions.salaryExpected <= 0)
    ) {
      _erros.salaryExpected = t("The salary must be greater than zero.");
    }

    if (interview.technologies?.length === 0) {
      _erros.technologies = t("At least one technical skill is required.");
    }
    if (interview.applicationDetails) {
      let applicationDetail = interview.applicationDetails
        .filter((x) => x.locked === false)
        .shift();
      if (applicationDetail) {
        if (!applicationDetail?.date)
          _erros.applicationDetailDate = t("application date is required.");
        if (!applicationDetail?.candidateSourceId)
          _erros.applicationDetailSource = t(
            " Candidate application Source is required."
          );
        if (!applicationDetail?.assignUserId)
          _erros.applicationDetailAssignUserId = t(
            " Candidate assign user is required."
          );
      }
    } else {
      _erros.applicationDetailDate = t("application date is required.");
      _erros.applicationDetailSource = t(
        " Candidate application Source is required."
      );
      _erros.applicationDetailAssignUserId = t(
        " Candidate assign user is required."
      );
    }

    for (let lang = 0; lang < interview.otherLanguages.length; lang++) {
      if (
        (interview.otherLanguages === undefined &&
          interview.otherLanguages[lang] === undefined) ||
        interview.otherLanguages[lang].language === undefined ||
        interview.otherLanguages[lang].language === 0 ||
        interview.otherLanguages[lang].language === null
      ) {
        if (_erros.otherLanguages === undefined) {
          _erros.otherLanguages = [{}];
        }

        if (_erros.otherLanguages[lang] === undefined) {
          _erros.otherLanguages[lang] = [0];
        }
        _erros.otherLanguages[lang].language = t("Please select a language.");
      }

      if (
        (interview.otherLanguages === undefined &&
          interview.otherLanguages[lang] === undefined) ||
        interview.otherLanguages[lang].languageLevel === undefined ||
        interview.otherLanguages[lang].languageLevel === 0 ||
        interview.otherLanguages[lang].languageLevel === null
      ) {
        if (_erros.otherLanguages === undefined) {
          _erros.otherLanguages = [{}];
        }

        if (_erros.otherLanguages[lang] === undefined) {
          _erros.otherLanguages[lang] = [0];
        }
        _erros.otherLanguages[lang].languageLevel = t(
          "Please select a language level."
        );
      }
    }

    return _erros;
  };

  const validateInterview = () => {
    setErrors(_validateInterview());
    return Object.keys(_validateInterview()).length === 0;
  };

  const validateInterviewMainInputs = () => {
    const errors = {};

    if (interview.personalInformation.emailAddress === false)
      errors.emailAddress = t("The Email Address is required.");

    return Object.keys(errors).length === 0;
  };

  const openModalInterviewHistory = () => {
    let history = [{}];
    (async () => {
      history = await InterviewService.getInterviewHistory(
        interview.interviewId
      );
      setInterviewHistory(history);
      setShowModalInterviewHistory(true);
    })();
  };

  const openFinancialCalculation = (fromUrl) => {
    if (!interview.isFinalized) {
      showWarning(
        t("Option unavailable because the interview is not finished")
      );
    } else {
      history.push(
        `/proposals/projectEstimation/${interview.interviewId}?returnUrl=interview/${fromUrl}/${interview.interviewId}?tab=documents`
      );
    }
  };

  function submitSendDocOnline() {
    InterviewService.sendDocOnline({
      interviewId: interview.interviewId,
      generatedLanguageId: interview.docOnlineLanguageId
    }).then((data) => {
      if (data === undefined) {
        setShowModalSendDNA(true);
      }
    });
  }
  function sendDocOnline() {
    if (
      !interview.personalInformation.fullName &&
      interview.personalInformation.emailAddress
    ) {
      toast.warning(
        `${t("Please fill in the name and email to send the Doc Online!")}`
      );
      return;
    }
    if (
      interview.hasPendingDocOnline === true ||
      interview.docOnlineStatus === "Expired"
    ) {
      showWarning(
        t(
          "A docOnline was already sent, do you wish to send another docOnline?"
        ),
        submitSendDocOnline
      );
      return;
    } else {
      submitSendDocOnline();
    }
  }

  function onchangeApplicationDetails({ target }) {
    let index = interview.applicationDetails
      .map((x) => x.id)
      .indexOf(interview.applicationDetailId);
    let applicationDetails = [...interview.applicationDetails];
    let applicationDetail = applicationDetails[index];
    applicationDetail[target.name] = target.value;
    setInterview({ ...interview, applicationDetails: applicationDetails });
  }

  return (
    <InterviewContext.Provider
      value={{
        addressZone,
        setAddressZone,
        GetAllAddressZone,
        numberOfDependents,
        maritalStatus,
        setMaritalStatus,
        GetAllMaritalStatus,
        interview,
        setInterview,
        nationality,
        setNationality,
        saveInterview,
        jobRoles,
        setJobRoles,
        candidateInterest,
        setCandidateInterest,
        submitForm,
        errors,
        setErrors,
        mobility,
        remoteWorkOptions,
        GetInterviewById,
        managerInterest,
        isTabsDisabled,
        setIsTabsDisabled,
        validateInterviewMainInputs,
        formReady,
        setFormReady,
        showModalInterviewHistory,
        setShowModalInterviewHistory,
        openModalInterviewHistory,
        interviewHistory,
        changeDataPreview,
        setChangeDataPreview,
        sendDocOnline,
        shoModalSendDNA,
        setShowModalSendDNA,
        isLoading,
        LoadParameters,
        setIsLoading,
        openFinancialCalculation,
        calculateGlobalRating,
        languageList,
        setRemoteWorkOptions,
        autoCompleteCourseData,
        setAutoCompleteCourseData,
        searchCourseData,
        setSearchCourseData,
        autoCompleteSchoolData,
        setAutoCompleteSchoolData,
        searchSchoolData,
        setSearchSchoolData,
        editMode,
        setEditMode,
        updateDocumentsGrid,
        setUpdatesDocumentsGrid,
        noticeList,
        availabilityStatus,
        contractTypes,
        docOnlineLanguages,
        documentLanguages,
        documentTypes,
        languageLevelList,
        techSkills,
        technologiesHierachy,
        setTechnologiesHierachy,
        messageAlertExistInterview,
        showModalAlertExistInterview,
        setShowModalAlertExistInterview,
        tabActive,
        setTabActive,
        getMotherLanguageDefault,
        initiateSkills,
        setLastInterviewInTheContext,
        monetaryList,
        onchangeApplicationDetails,
        newApplicationAvailable,

        setAvailabilityListStatus,
        availabilityListStatus,
        saveWithOutValidateInterview
      }}
    >
      {children}
    </InterviewContext.Provider>
  );
}

export function useInterviewContext() {
  return useContext(InterviewContext);
}
